module.exports = __webpack_public_path__ + "static/media/10.2d11d748.png";